const ParallaxImageRight = {
  getSettings: componentSettings => ({
    ...componentSettings,
    parallax: true,
    modifier: 'image-children-right'
  })
};

export default ParallaxImageRight;
